<section class="page">

  <header class="page-header">
    <div>
      <span class="eyebrow">Configurações</span>

      <h1>Restaurantes</h1>

      <p>
        Cadastre novos restaurantes ou atualize as informações
        dos estabelecimentos já existentes.
      </p>
    </div>
  </header>

  <div
    class="message error-message"
    *ngIf="error">

    {{ error }}
  </div>

  <div
    class="message success-message"
    *ngIf="success">

    {{ success }}
  </div>

  <!-- Formulário -->

  <section class="card form-card">

    <div class="form-header">
      <div>
        <h2>
          {{
            editingRestaurantId !== null
              ? 'Editar restaurante'
              : 'Novo restaurante'
          }}
        </h2>

        <p>
          {{
            editingRestaurantId !== null
              ? 'Altere os dados abaixo e salve as mudanças.'
              : 'Preencha as informações para cadastrar um restaurante.'
          }}
        </p>
      </div>

      <button
        type="button"
        class="cancel-button"
        *ngIf="editingRestaurantId !== null"
        (click)="cancelEdit()">

        Cancelar edição
      </button>
    </div>

    <div class="form-grid">

      <div class="field">
        <label>Nome do restaurante *</label>

        <input
          [(ngModel)]="form.name"
          placeholder="Ex: Pizzaria Central">
      </div>

      <div class="field">
        <label>Link público</label>

        <div class="slug-field">
          <span>/cardapio/</span>

          <input
            [(ngModel)]="form.slug"
            placeholder="pizzaria-central">
        </div>

        <small>
          Caso fique vazio, o backend gera o link usando o nome.
        </small>
      </div>

      <div class="field">
        <label>WhatsApp *</label>

        <input
          [(ngModel)]="form.whatsapp"
          inputmode="numeric"
          placeholder="Ex: 5581999999999">

        <small>
          Informe código do país, DDD e número.
        </small>
      </div>

      <div class="field">
        <label>Endereço</label>

        <input
          [(ngModel)]="form.address"
          placeholder="Rua, número e bairro">
      </div>

      <div class="field full-field">
        <label>Descrição</label>

        <textarea
          [(ngModel)]="form.description"
          rows="4"
          maxlength="500"
          placeholder="Descreva o restaurante e seus principais produtos">
        </textarea>
      </div>

      <div class="field">
        <label>Taxa de entrega</label>

        <input
          [(ngModel)]="form.deliveryFee"
          type="number"
          min="0"
          step="0.01"
          placeholder="0,00">
      </div>

      <div class="field">
        <label>Pedido mínimo</label>

        <input
          [(ngModel)]="form.minimumOrder"
          type="number"
          min="0"
          step="0.01"
          placeholder="0,00">
      </div>

      <div class="field full-field">
        <label>URL da logo</label>

        <input
          [(ngModel)]="form.logoUrl"
          placeholder="/uploads/restaurants/logo.png">

        <div
          class="image-preview"
          *ngIf="form.logoUrl">

          <img
            [src]="getImageUrl(form.logoUrl)"
            alt="Pré-visualização da logo">
        </div>
      </div>

      <div class="field full-field">
        <label>URL da imagem de capa</label>

        <input
          [(ngModel)]="form.coverUrl"
          placeholder="/uploads/restaurants/capa.png">

        <div
          class="image-preview cover-preview"
          *ngIf="form.coverUrl">

          <img
            [src]="getImageUrl(form.coverUrl)"
            alt="Pré-visualização da capa">
        </div>
      </div>

      <label class="open-control full-field">
        <input
          type="checkbox"
          [(ngModel)]="form.isOpen">

        <span class="switch">
          <span></span>
        </span>

        <span class="open-control-text">
          <strong>Restaurante aberto</strong>

          <small>
            Permitir que clientes façam novos pedidos.
          </small>
        </span>
      </label>

    </div>

    <div class="form-actions">
      <button
        type="button"
        class="save-button"
        [disabled]="loading"
        (click)="save()">

        {{
          loading
            ? 'Salvando...'
            : editingRestaurantId !== null
              ? 'Salvar alterações'
              : 'Salvar restaurante'
        }}
      </button>
    </div>

  </section>

  <!-- Lista -->

  <section class="list-section">

    <div class="list-header">
      <div>
        <h2>Restaurantes cadastrados</h2>

        <p>
          {{ restaurants.length }} restaurante(s)
        </p>
      </div>
    </div>

    <div
      class="empty-state"
      *ngIf="loadingRestaurants">

      Carregando restaurantes...
    </div>

    <div
      class="empty-state"
      *ngIf="!loadingRestaurants && !restaurants.length">

      Nenhum restaurante cadastrado.
    </div>

    <div class="restaurant-grid">

      <article
        class="restaurant-item"
        *ngFor="let restaurant of restaurants">

        <div class="restaurant-cover">

          <img
            *ngIf="restaurant.coverUrl"
            [src]="getImageUrl(restaurant.coverUrl)"
            [alt]="restaurant.name">

          <div
            class="cover-placeholder"
            *ngIf="!restaurant.coverUrl">
          </div>

          <span
            class="status"
            [class.closed]="!restaurant.isOpen">

            {{ restaurant.isOpen ? 'Aberto' : 'Fechado' }}
          </span>

        </div>

        <div class="restaurant-content">

          <div class="restaurant-title">

            <div class="restaurant-logo">

              <img
                *ngIf="restaurant.logoUrl"
                [src]="getImageUrl(restaurant.logoUrl)"
                [alt]="restaurant.name">

              <span *ngIf="!restaurant.logoUrl">
                {{ restaurant.name?.charAt(0) }}
              </span>

            </div>

            <div>
              <h3>{{ restaurant.name }}</h3>

              <small>
                /cardapio/{{ restaurant.slug }}
              </small>
            </div>

          </div>

          <p class="description">
            {{
              restaurant.description ||
              'Nenhuma descrição cadastrada.'
            }}
          </p>

          <div class="details">

            <div>
              <span>WhatsApp</span>

              <strong>
                {{ restaurant.whatsapp }}
              </strong>
            </div>

            <div>
              <span>Taxa de entrega</span>

              <strong>
                {{ formatMoney(restaurant.deliveryFee) }}
              </strong>
            </div>

            <div>
              <span>Pedido mínimo</span>

              <strong>
                {{ formatMoney(restaurant.minimumOrder) }}
              </strong>
            </div>

            <div>
              <span>Endereço</span>

              <strong>
                {{ restaurant.address || 'Não informado' }}
              </strong>
            </div>

          </div>

          <!-- QR Code -->

          <section class="qr-section">

            <div class="qr-header">
              <div>
                <span class="qr-label">
                  QR Code do cardápio
                </span>

                <h4>
                  Acesso rápido para as mesas
                </h4>

                <p>
                  O cliente pode apontar a câmera do celular
                  e abrir o cardápio deste restaurante.
                </p>
              </div>
            </div>

            <div
              class="qr-box"
              [id]="'qr-' + restaurant.id">

              <qrcode
                [qrdata]="publicLink(restaurant)"
                [width]="180"
                [errorCorrectionLevel]="'M'">
              </qrcode>
            </div>

            <div class="qr-public-link">
              <span>Link incluído no QR Code</span>

              <strong>
                {{ publicLink(restaurant) }}
              </strong>
            </div>

            <div class="qr-actions">

              <button
                type="button"
                class="download-qr-button"
                (click)="downloadQrCode(restaurant)">

                Baixar QR Code
              </button>

              <button
                type="button"
                class="print-qr-button"
                (click)="printQrCode(restaurant)">

                Imprimir para mesa
              </button>

            </div>

          </section>

          <div class="restaurant-actions">

            <a
              class="public-button"
              [href]="publicLink(restaurant)"
              target="_blank"
              rel="noopener noreferrer">

              Ver cardápio
            </a>

            <button
              type="button"
              class="edit-button"
              (click)="editRestaurant(restaurant)">

              Editar informações
            </button>

          </div>

        </div>

      </article>

    </div>

  </section>

</section>